import { UserLanguageEnum } from "@finway-group/shared/lib/models/user/userSettings.interface"
import en_US from "antd/lib/locale/en_US"
import moment from "moment"
// German date formats. Must be the dist (ESM) locale: vite resolves "moment" to
// the ESM build via jsnext:main, and the CJS moment/locale/de would register on a
// private CJS moment copy in the dev prebundle (dates silently stay English).
import "moment/dist/locale/de"
import { useEffect, useState } from "react"
import { i18n } from "~Shared/locales/i18n"
import { configLocaleNumberFormatting, getAntdLocale } from "~Shared/utils/helper.utils"

// importing a moment locale also activates it — reset to the default; the
// languageChanged handler applies the user's actual locale
moment.locale(UserLanguageEnum.EN)

/**
 * Keeps moment and number formatting in sync with the active i18n language and
 * returns the matching antd locale.
 */
export const useAppLocale = () => {
    const [antdLocale, setAntdLocale] = useState(en_US)

    useEffect(() => {
        const onLanguageChanged = (language: string) => {
            configLocaleNumberFormatting(language)
            moment.locale(language)
            setAntdLocale(getAntdLocale(language))
        }

        i18n.on("languageChanged", onLanguageChanged)

        return () => i18n.off("languageChanged", onLanguageChanged)
    }, [])

    return antdLocale
}
